module.exports = __webpack_public_path__ + "img/blackboardlight-k.13bc628d.png";